module.exports = __webpack_public_path__ + "img/profileSignedRestriction.7a818d26.svg";